import { j as e } from "../../jsx-runtime.BREq8dyb.js";
import { testIds as I } from "@decentriq/utils";
import { faFileArrowUp as N, faDatabase as P } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as u } from "@fortawesome/react-fontawesome";
import { DialogTitle as a, ModalClose as l, Divider as d, DialogContent as x, Box as m, Button as D, Link as k, DialogActions as O, Modal as w, ModalDialog as C } from "@mui/joy";
import { memo as v, useState as y, useMemo as A, Fragment as c } from "react";
import { Link as R } from "react-router-dom";
import _ from "../../components/DatasetReprovisioner/DatasetReprovisioner.js";
import { D as W } from "../../Prepper.Bv7VECW1.js";
var V = /* @__PURE__ */ ((t) => (t.UPLOAD_AND_PROVISION = "UPLOAD_AND_PROVISION", t.REPROVISION_EXISTING = "REPROVISION_EXISTING", t))(V || {});
const M = v(({
  DialogTitleChildren: t = "Provision dataset to node",
  DialogTitleProps: o,
  DatasetUploader: p = W,
  DatasetUploaderProps: h,
  DatasetReprovisioner: n = _,
  DatasetReprovisionerProps: f,
  onClose: s,
  onError: r,
  open: S = !0
}) => {
  const [j, i] = y(void 0), g = A(() => {
    switch (j) {
      case "UPLOAD_AND_PROVISION":
        return /* @__PURE__ */ e.jsxs(c, { children: [
          /* @__PURE__ */ e.jsxs(a, { ...o, children: [
            /* @__PURE__ */ e.jsx(l, { sx: {
              "--ModalClose-inset": "0.75rem"
            } }),
            t
          ] }),
          /* @__PURE__ */ e.jsx(d, { inset: "context" }),
          /* @__PURE__ */ e.jsx(p, { BackButtonProps: {
            onClick: () => {
              i(void 0);
            }
          }, ControllerWrapperComponent: O, OkayButtonProps: {
            onClick: () => {
              s?.();
            }
          }, ViewWrapperComponent: x, onError: r, ...h })
        ] });
      case "REPROVISION_EXISTING":
        return n ? /* @__PURE__ */ e.jsxs(c, { children: [
          /* @__PURE__ */ e.jsxs(a, { ...o, children: [
            /* @__PURE__ */ e.jsx(l, { sx: {
              "--ModalClose-inset": "0.75rem"
            } }),
            t
          ] }),
          /* @__PURE__ */ e.jsx(d, { inset: "context" }),
          /* @__PURE__ */ e.jsx(n, { BackButtonProps: {
            onClick: () => {
              i(void 0);
            }
          }, ControllerWrapperComponent: O, OkayButtonProps: {
            onClick: () => {
              s?.();
            }
          }, ViewWrapperComponent: x, onError: r, ...f })
        ] }) : null;
      case void 0:
      default:
        return /* @__PURE__ */ e.jsxs(c, { children: [
          /* @__PURE__ */ e.jsxs(a, { ...o, children: [
            /* @__PURE__ */ e.jsx(l, { sx: {
              "--ModalClose-inset": "0.75rem"
            } }),
            t
          ] }),
          /* @__PURE__ */ e.jsx(d, { inset: "context" }),
          /* @__PURE__ */ e.jsxs(x, { sx: {
            display: "flex",
            flexDirection: "column",
            pb: 0,
            pl: 1,
            pr: 1,
            pt: 0
          }, children: [
            /* @__PURE__ */ e.jsx(m, { sx: {
              flex: 1
            }, children: /* @__PURE__ */ e.jsxs(m, { sx: {
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              gap: "0.5rem",
              height: "100%",
              justifyContent: "center"
            }, children: [
              /* @__PURE__ */ e.jsxs(D, { "data-testid": I.dataroom.datasetProvisionDialog.import, onClick: () => i(
                "UPLOAD_AND_PROVISION"
                /* UPLOAD_AND_PROVISION */
              ), sx: {
                display: "flex",
                flexDirection: "row",
                gap: "0.5rem",
                lineHeight: 1.25,
                minWidth: 300,
                p: 2,
                whiteSpace: "nowrap"
              }, variant: "outlined", children: [
                /* @__PURE__ */ e.jsx(u, { fixedWidth: !0, icon: N, style: {
                  fontSize: "1.5rem"
                } }),
                /* @__PURE__ */ e.jsx("span", { children: "Import from my computer" })
              ] }),
              /* @__PURE__ */ e.jsxs(D, { "data-testid": I.dataroom.datasetProvisionDialog.storedDataset, onClick: () => i(
                "REPROVISION_EXISTING"
                /* REPROVISION_EXISTING */
              ), sx: {
                display: "flex",
                flexDirection: "row",
                gap: "0.5rem",
                lineHeight: 1.25,
                minWidth: 300,
                p: 2,
                whiteSpace: "nowrap"
              }, variant: "outlined", children: [
                /* @__PURE__ */ e.jsx(u, { fixedWidth: !0, icon: P, style: {
                  fontSize: "1.5rem"
                } }),
                /* @__PURE__ */ e.jsx("span", { children: "Choose from my stored datasets" })
              ] })
            ] }) }),
            /* @__PURE__ */ e.jsxs(m, { sx: {
              flex: 0,
              fontSize: "0.875rem",
              p: 1,
              textAlign: "center"
            }, children: [
              "To import datasets with data connectors please use the",
              " ",
              /* @__PURE__ */ e.jsx(k, { component: R, level: "inherit", sx: {
                fontWeight: 600
              }, to: "/datasets", children: "Datasets" }),
              " ",
              "page"
            ] })
          ] })
        ] });
    }
  }, [n, f, p, h, t, o, j, s, r]);
  return /* @__PURE__ */ e.jsx(w, { onClose: s, open: S, children: /* @__PURE__ */ e.jsx(C, { sx: {
    "--ModalDialog-maxWidth": "100%",
    "--ModalDialog-minWidth": "100%",
    height: "100%"
  }, children: g }) });
});
M.displayName = "DatasetProvisionDialog";
export {
  V as ProvisionBranch,
  M as default
};
//# sourceMappingURL=DatasetProvisionDialog.js.map
